import React, { useEffect, useState, useRef, useMemo } from "react";
import { SortByHeader } from "pages/Fleet/Cars/SortByHeader";
import { SearchHeader } from "pages/Fleet/Cars/SearchHeader";
import { ListView } from "pages/Fleet/Cars/ListView";
import { Container } from "pages/Fleet/Cars/CarStyled";
import { FleetFindCar } from "pages/Fleet/Cars/CarStyled";
import { useHookstate } from "@hookstate/core";
import { MESSAGE_FLEET_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "../../../globalStore/globalStore";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { LIST_BY_GLOBAL_STATES } from "globalStore/globalStore";
import { FLEET_GLOBAL_STATES } from "globalStore/globalStore";
import { fleetViewMode } from "constant";

import { COMMON_COMPONENTS_STATES } from "../../../globalStore/globalStore";
import { TagCarsComponent } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";
import { ActionWrapper } from "../../../pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import { TagCarsComponent1 } from "../../../commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";
import { getAllDevicesBySite } from "../../../redux/reduxToolkitServices/_commonServices/centralServices";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const Cars = () => {
  const { siteId, centralDeviceInfo } = useHookstate(SITEID_GLOBAL_STATE);

  const [height, setHeight] = useState(0);
  const [filterHeight, setFilterHeight] = useState(0);
  const [searchHeaderHeight, setSearchHeaderHeight] = useState(0);

  const filterDataRef = useRef(null);
  const filterH = useRef(null);
  const searchH = useRef(null);

  const [carListCount, setCarListCount] = useState(0);
  const [carListCountInvert, setCarListCountInvert] = useState(0);
  const [getFleetcarsInput, setGetFleetcarsInput] = useState("");
  const [getFleetcarsInputInvert, setGetFleetcarsInputInvert] = useState("");
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [disableselectAll, setDisableSelectAll] = useState(false);
  const [disableselectAllInvert, setDisableSelectAllInvert] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllInvert, setSelectAllInvert] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageInvert, setCurrentPageInvert] = useState(1);
  const [hideVehicleInfoColumns, setHideVehicleInfoColumns] = useState(false);
  const [toggleAppInfo, setToggleAppInfo] = useState(true);
  const [toggleSimInfo, setToggleSimInfo] = useState(true);
  const [toggleFTSWInfo, setToggleFTSWInfo] = useState(true);
  const [collapseTop, setCollapseTop] = useState(false);
  const [collapseBottom, setCollapseBottom] = useState(false);

  useEffect(() => {
    const fetchCentralInfo = async () => {
      const centralInfo = await getAllDevicesBySite(siteId.get());
      centralDeviceInfo.set(centralInfo);
    };

    fetchCentralInfo();
  }, [siteId.get()]);

  useEffect(() => {
    setCurrentPage(1);
    setCurrentPageInvert(1);
  }, [getFleetcarsInput, getFleetcarsInputInvert, rowsPerPage]);

  useEffect(() => {
    if (rowsPerPage === "All") return;
    const totalPages = Math.ceil(carListCount / rowsPerPage);
    if (currentPage > totalPages) {
      setCurrentPage(totalPages || 1);
    }
  }, [carListCount, rowsPerPage]);

  useEffect(() => {
    if (rowsPerPage === "All") return;
    const totalPagesInvert = Math.ceil(carListCountInvert / rowsPerPage);
    if (currentPageInvert > totalPagesInvert) {
      setCurrentPageInvert(totalPagesInvert || 1);
    }
  }, [carListCountInvert, rowsPerPage]);

  const dispatch = useDispatch();
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const { showTagCarsState, showTagCarsStatenew, showTagCarState2 } =
    useHookstate(COMMON_COMPONENTS_STATES);

  const { listBy } = useHookstate(LIST_BY_GLOBAL_STATES);
  const { toggleFleetCarList } = useHookstate(FLEET_GLOBAL_STATES);

  const { getCarsData, siteSettingDataReduxStateStatus } = useSelector((state) => state?.commonReducers) || [];

  const TopSection = `${windowDimensions.width <= 850
    ? filterHeight + searchHeaderHeight + 58 + 70
    : filterHeight + searchHeaderHeight + 58
    }`;

  const totalHeight = `${windowDimensions.width <= 850
    ? height + filterHeight + searchHeaderHeight + filterHeight + 58 + 70
    : height + filterHeight + searchHeaderHeight + filterHeight + 58
    }`;

  const listMaxHeight = useMemo(() => {
    return listBy.get() !== "NONE"
      ? "230px"
      : `calc(100vh - ${TopSection}px)`;
  }, [listBy.get(), TopSection]);

  const listMaxHeightTotalWeight = useMemo(() => {
    return windowDimensions.width <= 850 && window.innerHeight <= window.innerWidth
      ? "400px"
      : `calc(100vh - ${totalHeight}px)`
  }, [listBy.get(), totalHeight]);

  useEffect(() => {
    let timeout;
    function handleResize() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setWindowDimensions(getWindowDimensions());
      }, 150);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (filterDataRef.current?.clientHeight === null) {
      return;
    } else {
      setHeight(filterDataRef.current?.clientHeight);
    }
  }, [listBy.get()]);

  //-------filter height ---------------
  useEffect(() => {
    if (filterH.current?.clientHeight === null) {
      return;
    } else {
      setFilterHeight(filterH.current?.clientHeight);
    }
  }, [listBy.get()]);

  //-------Search Header height ---------------
  useEffect(() => {
    if (searchH.current?.clientHeight === null) {
      return;
    } else {
      setSearchHeaderHeight(searchH.current?.clientHeight);
    }
  }, [listBy.get()]);

  useEffect(() => {
    if (toggleFleetCarList.get() !== fleetViewMode.TableList) {
      return;
    }

    let disposed = false;
    let bound = false;
    let cleanup = () => {};

    const pinBottomScrollbar = () => {
      const scrollbars = Array.from(
        document.querySelectorAll(".table-ui .MuiDataGrid-scrollbar--horizontal")
      );
      const visibleBar = scrollbars.find((bar) => {
        if (window.getComputedStyle(bar).display === "none") return false;
        const root = bar.closest(".MuiDataGrid-root");
        return root && root.getBoundingClientRect().width > 0;
      });
      if (!visibleBar) return;
      const gridRoot = visibleBar.closest(".MuiDataGrid-root");
      if (!gridRoot) return;
      const rect = gridRoot.getBoundingClientRect();
      Object.assign(visibleBar.style, {
        position: "fixed",
        left: `${rect.left}px`,
        right: "auto",
        bottom: "4px",
        width: `${rect.width}px`,
        zIndex: "30",
      });
    };

    const resetScrollbars = () => {
      document
        .querySelectorAll(".table-ui .MuiDataGrid-scrollbar--horizontal")
        .forEach((bar) => {
          bar.style.position = "";
          bar.style.left = "";
          bar.style.right = "";
          bar.style.bottom = "";
          bar.style.width = "";
          bar.style.zIndex = "";
        });
    };

    const setup = () => {
      if (disposed || bound) return;

      const scrollers = Array.from(
        document.querySelectorAll(".table-ui .MuiDataGrid-virtualScroller")
      );
      if (scrollers.length < 2) return;

      const [topScroller, bottomScroller] = scrollers;
      bound = true;
      let syncing = false;

      const syncScroll = (source, target) => () => {
        if (syncing) return;
        if (source.scrollLeft === target.scrollLeft) return;
        syncing = true;
        target.scrollLeft = source.scrollLeft;
        requestAnimationFrame(() => {
          syncing = false;
        });
      };

      const onTopScroll = syncScroll(topScroller, bottomScroller);
      const onBottomScroll = syncScroll(bottomScroller, topScroller);

      topScroller.addEventListener("scroll", onTopScroll);
      bottomScroller.addEventListener("scroll", onBottomScroll);

      cleanup = () => {
        topScroller.removeEventListener("scroll", onTopScroll);
        bottomScroller.removeEventListener("scroll", onBottomScroll);
        resetScrollbars();
      };

      pinBottomScrollbar();
    };

    const raf = requestAnimationFrame(() => {
      setup();
      pinBottomScrollbar();
    });
    const timers = [
      setTimeout(() => {
        setup();
        pinBottomScrollbar();
      }, 250),
      setTimeout(() => {
        setup();
        pinBottomScrollbar();
      }, 700),
    ];

    return () => {
      disposed = true;
      cancelAnimationFrame(raf);
      timers.forEach(clearTimeout);
      cleanup();
      resetScrollbars();
    };
  }, [
    toggleFleetCarList.get(),
    listBy.get(),
    carListCount,
    carListCountInvert,
    collapseTop,
    collapseBottom,
    windowDimensions,
  ]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
  }, [siteId.get()]);

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST || getCarsData === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  const showFixedHScroll =
    toggleFleetCarList.get() === fleetViewMode.TableList;

  return (
    <>
      <Container
        style={{
          backgroundColor: isLoading.get() ? "#f7f7f7" : "",
          paddingBottom: showFixedHScroll ? "20px" : "",
        }}
      >
        <div ref={filterH}>
          <SortByHeader />
        </div>
        <div ref={searchH}>
          <SearchHeader
            invert={false}
            count={carListCount}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            disableselectAll={disableselectAll}
            disableselectAllInvert={disableselectAllInvert}
            getFleetcarsInput={getFleetcarsInput}
            setGetFleetcarsInput={setGetFleetcarsInput}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            hideVehicleInfoColumns={hideVehicleInfoColumns}
            setHideVehicleInfoColumns={setHideVehicleInfoColumns}
            toggleAppInfo={toggleAppInfo}
            setToggleAppInfo={setToggleAppInfo}
            toggleSimInfo={toggleSimInfo}
            setToggleSimInfo={setToggleSimInfo}
            toggleFTSWInfo={toggleFTSWInfo}
            setToggleFTSWInfo={setToggleFTSWInfo}
            collapsed={collapseTop}
            setCollapsed={setCollapseTop}
          />
        </div>
        {showTagCarsState.get() || showTagCarState2.get() ? <TagCarsComponent /> : <></>}
        {showTagCarsStatenew.get() ? <TagCarsComponent1 /> : <></>}

        <div ref={filterDataRef}>
          <div style={{ display: collapseTop ? "none" : "block" }}>
          <ListView
            invert={false}
            hideOwnHorizontalScrollbar={listBy.get() !== "NONE" && !collapseBottom}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            setDisableSelectAll={setDisableSelectAll}
            setDisableSelectAllInvert={setDisableSelectAllInvert}
            setCarListCount={setCarListCount}
            maxHeight={listMaxHeight}
            getFleetcarsInput={getFleetcarsInput}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            hideVehicleInfoColumns={hideVehicleInfoColumns}
            toggleAppInfo={toggleAppInfo}
            toggleSimInfo={toggleSimInfo}
            toggleFTSWInfo={toggleFTSWInfo}
          />
          </div>
        </div>
        {listBy.get() !== "NONE" && (
          <>
            <SearchHeader
              invert={true}
              count={carListCountInvert}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              disableselectAll={disableselectAll}
              disableselectAllInvert={disableselectAllInvert}
              className="new-search-header"
              getFleetcarsInput={getFleetcarsInputInvert}
              setGetFleetcarsInput={setGetFleetcarsInputInvert}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPageInvert}
              setCurrentPage={setCurrentPageInvert}
              hideVehicleInfoColumns={hideVehicleInfoColumns}
              setHideVehicleInfoColumns={setHideVehicleInfoColumns}
              toggleAppInfo={toggleAppInfo}
              setToggleAppInfo={setToggleAppInfo}
              toggleSimInfo={toggleSimInfo}
              setToggleSimInfo={setToggleSimInfo}
              toggleFTSWInfo={toggleFTSWInfo}
              setToggleFTSWInfo={setToggleFTSWInfo}
              collapsed={collapseBottom}
              setCollapsed={setCollapseBottom}
            />
            {showTagCarsState.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            {showTagCarState2.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}
            {showTagCarsStatenew.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent1 />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            <div style={{ display: collapseBottom ? "none" : "block" }}>
            <ListView
              invert={true}
              hideOwnHorizontalScrollbar={false}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              setDisableSelectAll={setDisableSelectAll}
              setDisableSelectAllInvert={setDisableSelectAllInvert}
              setCarListCountInvert={setCarListCountInvert}
              maxHeight={listMaxHeightTotalWeight}
              getFleetcarsInput={getFleetcarsInputInvert}
              rowsPerPage={rowsPerPage}
              currentPage={currentPageInvert}
              hideVehicleInfoColumns={hideVehicleInfoColumns}
              toggleAppInfo={toggleAppInfo}
              toggleSimInfo={toggleSimInfo}
              toggleFTSWInfo={toggleFTSWInfo}
            />
          </div>
          </>
        )}
      </Container>
    </>
  );
};